import { iStore } from "store/store.model";

export const selectPreviousDomain = (state: iStore) =>
  state.preferences.previousDomain;
